/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type BulkMatchRequestField = typeof BulkMatchRequestField[keyof typeof BulkMatchRequestField];


export const BulkMatchRequestField = {
  companies: 'companies',
  universities: 'universities',
  job_titles: 'job_titles',
  skills: 'skills',
  investors: 'investors',
  locations: 'locations',
} as const;
